import styled from 'styled-components'
import { SpaceProps, space } from 'styled-system'

import { hex2rgba } from '@/helpers/hex-to-rgba'
import { filterSpaceProps } from '@/helpers/styled-props'

export const StyledSwitch = styled.div.withConfig({
  shouldForwardProp: filterSpaceProps(),
})<SpaceProps>`
  display: flex;
  align-items: center;
  ${space}
`

export const Slider = styled.label`
  position: relative;
  display: inline-block;
  cursor: pointer;
  width: 34px;
  min-width: 34px;
  height: 14px;
  min-height: 14px;
  background-color: ${({ theme }) => hex2rgba(theme.colors.violet, 0.5)};
  border-radius: 7px;
  transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &:after {
    position: absolute;
    left: 0;
    top: -25%;
    display: block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.white};
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);
    content: '';
  }
`
export const Label = styled.label`
  margin-left: ${({ theme }) => theme.space.S8};
  font-size: 0.875rem;
  line-height: 1.46429em;
  cursor: pointer;
`

export const Input = styled.input`
  display: none;

  &:checked ~ ${Slider} {
    &:after {
      left: 50%;
      background: ${({ theme }) => theme.colors.violet};
    }
  }
`
